import React from 'react';
import { Instagram, Youtube, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative w-full border-t border-[rgba(34,230,230,0.2)] bg-black py-14">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-display font-black text-white text-2xl tracking-widest">
            SQUARE <span className="text-[color:var(--sd-cyan)] sd-glow">DARTS</span>
          </div>
          <div className="mt-2 text-[10px] tracking-[0.3em] text-[color:var(--sd-muted)] font-mono">
            BRASIL // ONLINE DARTS
          </div>
          <p className="mt-4 text-sm text-[color:var(--sd-text)]/70 font-mono leading-relaxed">
            Rede profissional de dardos eletrônicos, competições e comunidade.
          </p>
        </div>
        <div>
          <div className="font-display text-[color:var(--sd-cyan)] tracking-[0.2em] text-sm mb-4">NAVEGAR</div>
          <ul className="space-y-2 font-mono text-sm text-[color:var(--sd-text)]/80">
            <li><a href="/#top" className="hover:text-[color:var(--sd-cyan)] transition-colors">Início</a></li>
            <li><a href="/#categorias" className="hover:text-[color:var(--sd-cyan)] transition-colors">Categorias</a></li>
            <li><a href="/torneios" className="hover:text-[color:var(--sd-cyan)] transition-colors">Torneios Internacionais</a></li>
            <li><a href="/#distribuidor" className="hover:text-[color:var(--sd-cyan)] transition-colors">Distribuidor</a></li>
          </ul>
        </div>
        <div>
          <div className="font-display text-[color:var(--sd-cyan)] tracking-[0.2em] text-sm mb-4">CONTATO</div>
          <ul className="space-y-2 font-mono text-sm text-[color:var(--sd-text)]/80">
            <li>squaredartsbr@gmail.com</li>
            <li>
              <a href="https://wa.me/351969584190" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="hover:text-[color:var(--sd-cyan)] transition-colors">
                WhatsApp: +351 969 584 190
              </a>
            </li>
            <li>São Paulo · Brasil</li>
          </ul>
        </div>
        <div>
          <div className="font-display text-[color:var(--sd-cyan)] tracking-[0.2em] text-sm mb-4">CANAIS</div>
          <div className="flex items-center gap-4">
            <a href="https://www.instagram.com/square.darts.brasil?stkn=ZzZqNjYxb3A0cXZ4&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-9 h-9 border border-[rgba(34,230,230,0.4)] flex items-center justify-center text-[color:var(--sd-cyan)] hover:bg-[color:var(--sd-cyan)] hover:text-black transition-colors"><Instagram size={16} /></a>
            <a href="#" className="w-9 h-9 border border-[rgba(34,230,230,0.4)] flex items-center justify-center text-[color:var(--sd-cyan)] hover:bg-[color:var(--sd-cyan)] hover:text-black transition-colors"><Youtube size={16} /></a>
            <a href="#" className="w-9 h-9 border border-[rgba(34,230,230,0.4)] flex items-center justify-center text-[color:var(--sd-cyan)] hover:bg-[color:var(--sd-cyan)] hover:text-black transition-colors"><Mail size={16} /></a>
          </div>
        </div>
      </div>
      <div className="mt-12 max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4 text-[10px] tracking-[0.3em] text-[color:var(--sd-muted)] font-mono">
        <div>© {new Date().getFullYear()} SQUARE DARTS BRASIL · TODOS OS DIREITOS RESERVADOS</div>
        <div>[ STATUS: ONLINE // v.2027.03 ]</div>
      </div>
    </footer>
  );
}
